// Publication tags used for tagging and filtering publications.
// These are also used as customer publicationAccess values.
// id is the canonical storage value (Customer.publicationAccess, blob metadata, outlook configs).
// label is the human-readable display string shown in the UI.
export const publicationTags = [
  // Global outlooks
  { id: 'crude',                    label: 'Global Crude Oil' },
  { id: 'fuels',                    label: 'Global Fuels' },
  { id: 'petrochemical-feedstocks', label: 'Global Petrochemical Feedstocks' },
  { id: 'refining',                 label: 'Global Refining' },
  { id: 'renewable-fuels',          label: 'Renewable Fuels' },
  { id: 'long-term-global-oil-balance', label: 'Long-Term Global Oil Balance' },
  // Regional outlooks
  { id: 'africa',                   label: 'Africa' },
  { id: 'asia',                     label: 'Asia' },
  { id: 'china',                    label: 'China' },
  { id: 'cis',                      label: 'CIS' },
  { id: 'europe',                   label: 'Europe' },
  { id: 'latin-america',            label: 'Latin America' },
  { id: 'middle-east',              label: 'Middle East' },
  { id: 'north-america',            label: 'North America' },
  // Cross-cutting
  { id: 'weekly-alert',             label: 'Weekly Alert' },
  { id: 'market-alert',             label: 'Market Alert' },
  { id: 'crude-briefing',           label: 'Intelligence Brief' },
];
